package one.healthium.log_water.ui.internal

import androidx.compose.runtime.Immutable
import kotlin.math.max

@Immutable
internal data class LogWaterUiModel(
    val dailyAmount: Float,
    val currentValue: Float,
    val additionValue: Float = 0f,
) {
    val value = max(0f, currentValue + additionValue)
    val progress: Float = if (dailyAmount == 0f) 0f else value / dailyAmount
}
